/*
 * Профиль и безопасность: 1-Э1.10 (администратор, колонка 640) и 5-М7 (мастер, 360).
 * Блоки — карточки на рабочем фоне, как на листе; числа — токены библиотеки.
 */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  width: 100%;
  max-width: 640px;
  padding: var(--space-4);
  margin: 0 auto;
}

.header {
  display: flex;
  gap: var(--space-3);
  align-items: center;
}

.avatar {
  display: grid;
  flex: none;
  place-items: center;
  width: 44px;
  height: 44px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-on-nav);
  background: var(--accent);
  border-radius: 50%;
}

.headerMain {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.name {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.muted {
  /* Поля абзаца обнуляются: браузерные 1em у <p> давали блоку «Язык интерфейса»
     лишние 13 px сверху и снизу, и он выглядел рыхлее соседних. */
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.blockHead {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  justify-content: space-between;
}

/*
 * Заголовок блока задан ЯВНО, а не унаследован. Блок «Язык интерфейса» размечен h2
 * (у него свой смысл для чтения с экрана), и браузерный h2 давал ему полуторный кегль
 * и поля — он выглядел чужим среди «Пароля» и «Второго фактора». Разметка может
 * отличаться, вид — нет.
 */
.blockTitle {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  line-height: 1.3;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.hint {
  margin: 0;
  font-size: var(--font-size-sm);
  line-height: 1.45;
  color: var(--text-secondary);
}

.notice {
  padding: 8px 10px;
  font-size: var(--font-size-sm);
  color: var(--info-fg);
  background: var(--info-bg);
  border-radius: 10px;
}

.error {
  font-size: var(--font-size-sm);
  color: var(--danger);
}

.sessions {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style: none;
}

.session {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid var(--grid-line-minor);
}

.sessionMain {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.facts {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 12px;
  margin: 0;
  font-size: var(--font-size-sm);
}

.facts dt {
  color: var(--text-secondary);
}

.facts dd {
  margin: 0;
}

/* Языки в ряд: их два-три, и выпадающий список на такое число вариантов только
   прячет выбор за лишним нажатием. */
.languages {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

/*
 * ВТОРОЙ ФАКТОР.
 *
 * Ключ и резервные коды — единственное место в кабинете, где моноширинный шрифт нужен
 * по делу, а не для вида: строки переписывают с экрана на бумагу и вводят руками, и
 * «l» рядом с «1» в пропорциональном шрифте отличить нельзя.
 */
.secret {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-2);
  margin: 0;
  font-family: var(--font-mono, ui-monospace, Menlo, monospace);
  font-size: var(--font-size-md);
  letter-spacing: 0.08em;
}

.secretGroup {
  padding: 2px 6px;
  background: var(--bg-sunken);
  border-radius: var(--radius-xs);
}

.codes {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: var(--space-1) var(--space-2);
  padding: 10px 12px;
  margin: 0;
  list-style: none;
  background: var(--bg-sunken);
  border-radius: 10px;
}

.codeItem {
  font-family: var(--font-mono, ui-monospace, Menlo, monospace);
  font-size: var(--font-size-md);
  letter-spacing: 0.06em;
}

/* Коды на исходе — предупреждение, а не подпись: их замечают только выделенными. */
.warnLine {
  margin: 0;
  font-size: var(--font-size-sm);
  line-height: 1.45;
  /* Тот же тёплый янтарь, которым в кабинете помечено «требует внимания». */
  color: var(--status-pending-fg);
}
